import { ApiProperty } from "@nestjs/swagger";

export class DriverId {
  @ApiProperty()
  id: number;
}